export enum FieldType {
  none = 0,
  integer = 1,
  date = 2,
  text = 3,
  floating = 4,
  boolean = 5,
  correlationKey = 6
}
